import React from 'react';
import { observer } from 'mobx-react';

import { MarkHotkey } from 'libs/editor/plugins/helpers/markHotKey';
import { RenderMark } from 'libs/editor/plugins/helpers/renderMark';
import { HasMark } from 'libs/editor/plugins/helpers/hasMark';

const BoldMark = observer(({ children }) => <strong>{children}</strong>);

const type = 'BOLD';

export function Bold() {
  return {
    button: {
      elementType: 'mark',
      type,
      active: value => HasMark(type, value),
      handleClick: store => {
        const { reference, onChange } = store;
        reference.toggleMark(type);
        onChange(reference);
      },
    },
    plugins: [
      MarkHotkey({ key: 'b', type }),
      RenderMark(type, props => <BoldMark {...props} />),
    ],
  };
}
